<template>
  <div class="guide">
    <div class="card-guide-body">
      <button-toolbar
          :items="rsvps"
          :status="status"
          @add-item-click="handleAddItemClick"
          @status-click="handleStatusClick"
          @search-input="handleSearchInput"
      />
      <data-table
          :items="rsvps"
          @update-rsvp-click="handleUpdateRSVPClick"
      />
    </div>
    <add-edit-item-modal
        :ref="addEditItemModalId"
        :item-status-modal-id="addEditItemModalId"
        :profile="profile"
        @item-added="handleItemAddedUpdated"
        @item-updated="handleItemAddedUpdated"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import AddEditItemModal from "./addEditItemModal";
import ButtonToolbar from "./buttonToolbar";
import DataTable from "./dataTable";

import moment from "moment";
export default {
  name:"RSVP_Forms",
  components: {
    AddEditItemModal,
    DataTable,
    ButtonToolbar
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      allRSVPs: "admin/rsvps"
    }),
    rsvps() {
      if (this.searchStr.trim() == "") return this.allRSVPs;
      let filtered = [];

      let searchStrTrim = this.searchStr.toLowerCase().trim();

      filtered = this.allRSVPs.filter(anRSVP => {
        return (
            (anRSVP.form && anRSVP.form.name && anRSVP.form.name.toLowerCase().includes(searchStrTrim)) ||
            (anRSVP.form && anRSVP.form.email && anRSVP.form.email.toLowerCase().includes(searchStrTrim)) ||
            (anRSVP.form && anRSVP.form.note && Array.isArray(anRSVP.form.note) && JSON.stringify(anRSVP.form.note).toLowerCase().includes(searchStrTrim))
        );
      });

      return filtered;
    }
  },
  mounted() {},
  methods: {
    handleActivation() {
      this.getRSVPs();
    },
    getRSVPs(){
      this.$store.dispatch("admin/getRSVPs").then((res)=>{
        console.log(res);
      });
    },
    formatDate(date) {
      return date
        ? moment(date.toDate()).format("MMMM DD, YYYY h:MM a")
        : "N/A";
    },
    handleAddItemClick() {
      if (this.$refs[this.addEditItemModalId].hasOwnProperty("handleAddItem")) {
        this.$refs[this.addEditItemModalId].handleAddItem();
      }
    },
    handleUpdateRSVPClick(item) {
      if (
          this.$refs[this.addEditItemModalId].hasOwnProperty("handleUpdateItem")
      ) {
        this.$refs[this.addEditItemModalId].handleUpdateItem(item);
      }
    },
    handleStatusClick(status) {
      this.status = status;
    },
    handleSearchInput(search) {
      this.searchStr = search;
    },
    handleItemAddedUpdated(item) {
      this.$store.dispatch("user/showNotification", {
        title: `A Memory Added ${item && item.name ? item.name : ""} !'}`,
        description: `Your item has been added`,
        variant: "success"
      });
      this.getRSVPs();
    }
  },
  data() {
    return {
      searchStr: "",
      status: 'all',
      addEditItemModalId: "add-edit-status-modal-rsvp",
      btnText: "Approve",
      transProps: {
        name: "flip-list" // Transition name
      },
      fields: [
        { key: "email", sortable: true, label: "Email" },
        { key: "ip_address", sortable: true, label: "IP Address " },
        {
          key: "_created_at",
          sortable: true,
          label: "Submitted",
          formatter: "formatDate"
        }
        // { key: "actions", label: "Actions" }
        //     { key: "show_details", label: "Show Details" }
      ],
      currentPage: 1,
      perPage: 50,
      pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
      selectedUser: {},
      showUserNotify: true
    };
  }
};
</script>
<style lang="scss" scoped>
.card-guide {
  box-shadow: none;
}
</style>
